import React from 'react'
import { Dropdown, Menu, Space } from 'antd'
import { useTranslation } from 'next-i18next'
import { DownOutlined } from '@ant-design/icons'
import styles from './DepositMenuActions.module.scss'
import DeleteButton from './DeleteButton/DeleteButton'
import DownloadCsvButton from './DownloadCsvButton/DownloadCsvButton'
import DownloadAllDeposits from './DownloadAllDeposits/DownloadAllDeposits'

const DepositMenuActions = () => {
  const { t } = useTranslation()

  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu
          items={[
            { key: '1', label: <DownloadCsvButton /> },
            { key: '2', label: <DownloadAllDeposits /> },
            { key: '3', label: <DeleteButton /> },
          ]}
        />
      }
      className={styles['margin-with']}
    >
      <a onClick={e => e.preventDefault()} className={`${styles['btnMore']} label-input`}>
        <Space>
          {t('Deposits.MoreActions')}
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  )
}

export default DepositMenuActions
